import * as React from "react";

const InformationPage: React.FC<{ children?: React.ReactNode }> = (props) => (
  <div>{props.children}</div>
);

export default InformationPage;
